<template>
    <layout theme="white">
        <AddReportComp />
    </layout>
</template>

<script>
    import AddReportComp from "@/components/AddReportComp";
    export default {
        name: "AddReport",
        components: {
            AddReportComp
        }
    }
</script>